import { createContext } from 'react';
import PortfolioMode from '../constants/PortfolioMode.enum';

const PortfolioModeContext = createContext<PortfolioMode>(
  PortfolioMode.STUDENT,
);

export default PortfolioModeContext;
